import { css } from 'styled-components';
import colors from '@tcp/core/styles/themes/TCP/colors';

const styles = css`
  border-left: solid 3px ${(props) => props.theme.colors.REWARDS.PLCC};
  border-top: solid 3px ${(props) => props.theme.colors.REWARDS.PLCC};
  border-right: solid 3px ${(props) => props.theme.colors.REWARDS.NON_PLCC};
  border-bottom: solid 3px ${(props) => props.theme.colors.REWARDS.NON_PLCC};
  text-align: center;
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
  background: ${(props) => props.theme.colors.WHITE};
  border-radius: 5px;
  margin: ${(props) => props.theme.spacing.ELEM_SPACING.MED}
    ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  .plccWrapper {
    padding-top: 0px;
    padding-bottom: 6px;
    position: relative;
  }
  .text-style-1 {
    color: ${(props) => props.theme.colors.TEXT.ORANGE};
    text-transform: uppercase;
  }
  .text-style-2 {
    color: ${(props) => props.theme.colors.TEXT.LIGHTBLUE};
    text-transform: uppercase;
  }
  .text-style-3 {
    color: ${(props) => props.theme.colors.TEXT.DARKPINK};
    text-transform: uppercase;
  }
  .text-style-4 {
    color: ${(props) => props.theme.colors.TEXT.DARKERGRAY};
    text-transform: uppercase;
  }
  .shipping-style {
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
  }
  .address-text-style {
    ${(props) =>
      !props.rememberedUserFlag &&
      `color:${colors.BUTTON.BLUE.LEFT_FILTERS_BTN};text-decoration: underline;cursor:pointer`};

    font-weight: 800;
  }
  .checkout {
    width: 94%;
    border: solid 4px ${(props) => props.theme.colors.PROMO.PINK};
    height: 48px;
    box-shadow: 4px 4px ${(props) => props.theme.colors.DEFAULT_ACCENT_GYM},
      8px 8px ${(props) => props.theme.colors.PLCC_BACKGROUND};
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
  }
  .seperator {
    width: 30%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    line-height: 0.1em;
  }

  .seperator-style {
    background: ${(props) => props.theme.colors.WHITE};

    padding: 0 10px;
    line-height: 0.1em;
  }
  .store-name {
    text-transform: capitalize;
  }
  .card-footer {
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
  }
  .tool-tip-style {
    position: absolute;
    display: inline-block;
    right: -1%;
    top: -5%;
  }
  .circle-info-image {
    width: 13px;
    height: 13px;
  }
  .tooltip-bubble {
    ::before {
      right: 39%;
    }
  }
  .address-wrapper {
    display: inline-block;
    width: 98%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tooltip-message p {
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
  }
  .tool-msg {
    margin: 10px;
    height: 129px;
    width: 244px;
    right: 83px;
    /* left: -122px; */
    position: relative;
  }
  .username-text-style {
    color: ${colors.BUTTON.BLUE.LEFT_FILTERS_BTN};
    text-decoration: underline;
    cursor: pointer;
    font-weight: 800;
  }
  .store-address {
    font-weight: bolder;
    cursor: pointer;
    text-transform: capitalize;
  }
  .cardTile__img_wrapper {
    width: 28px;
    height: 18px;
  }
  .cardTile__img {
    width: 100%;
  }
`;
export default styles;
